import i18next from '@/config/i18n'
import { LANGUAGES, DEFAULT_LANGUAGE } from '@/constants/languages'

/**
 * Resolve the 2-letter language code to request when reading legal documents
 * from the backend (`?lang=`). The backend accepts only `pt | en | es` and
 * returns 422 for anything else, so we normalise `i18next.language` (which can
 * be a full locale such as `pt-BR` / `en-US` when detected from the browser)
 * down to its base code and fall back to PT when unsupported.
 *
 * @returns {'pt' | 'en' | 'es'}
 */
export function getDocumentLang() {
    const raw = i18next.language || DEFAULT_LANGUAGE
    const base = raw.split('-')[0].toLowerCase()
    return base in LANGUAGES ? base : DEFAULT_LANGUAGE
}

/**
 * Given the backend's `published_langs` list and the currently displayed
 * language, return the language that is ACTUALLY being shown — i.e. the
 * requested language when it has a published translation, otherwise the PT
 * fallback that the backend serves.
 *
 * @param {string[]} publishedLangs
 * @param {string} [lang] - defaults to the current document language
 * @returns {'pt' | 'en' | 'es'}
 */
export function getDisplayedLang(publishedLangs, lang = getDocumentLang()) {
    return Array.isArray(publishedLangs) && publishedLangs.includes(lang)
        ? lang
        : DEFAULT_LANGUAGE
}
